import {Col, Row} from '@jetbrains/ring-ui/components/grid/grid'
import classNames from 'classnames'
import * as React from 'react'

import styles from './ParameterRow.css'

type Props = {
  name1: string | null | undefined
  start1: string | null | undefined
  finish1: string | null | undefined
  name2: string | null | undefined
  start2: string | null | undefined
  finish2: string | null | undefined
  changed?: boolean | null | undefined
}

function ParameterValue({
  start,
  finish,
}: {
  start: string | null | undefined
  finish: string | null | undefined
}) {
  const value =
    start != null && finish != null && start !== finish
      ? `${finish} (changed, original value: ${start})`
      : start ?? finish
  const empty = value == null || value.length === 0
  return (
    <Col
      xs={6}
      className={classNames(styles.value, {
        [styles.empty]: empty,
      })}
    >
      {/* eslint-disable-next-line react/no-array-index-key */}
      {empty ? 'No data' : value?.split('\n').map((line, i) => <div key={i}>{line}</div>)}
    </Col>
  )
}

function ParameterRow({name1, start1, finish1, name2, start2, finish2, changed}: Props) {
  return (
    <Row className={styles.row}>
      <Col xs={12} className={styles.col}>
        <div className={styles.name}>{name1 ?? name2}</div>
        <Row
          className={classNames(styles.values, {
            [styles.changed]: changed,
          })}
        >
          <ParameterValue start={start1} finish={finish1} />
          <ParameterValue start={start2} finish={finish2} />
        </Row>
      </Col>
    </Row>
  )
}

export default ParameterRow
